import { Box, Typography } from "@mui/material";

export function PropValueLine({ label, value, labelWidth = 100 }: { label: string, value: any, labelWidth?: number }) {
  return (
    <Box display="flex" alignItems="center" mb={1}>
      <Box sx={{ minWidth: `${labelWidth}px`, overflow: 'hidden', textOverflow: 'ellipsis', width: `${labelWidth}px` }}>
        <Typography variant="body1" sx={{ textAlign: 'right', paddingRight: '4px' }} >{label}:</Typography>
      </Box>
      <Box sx={{ flexGrow: 1, borderLeft: '1px solid #ccc', paddingLeft: '8px', textAlign: 'left' }}>
        {(typeof value === 'string') ? <Typography sx={{ textTransform: 'none' }} variant="body1">{value}</Typography> : value}
      </Box>
    </Box>
  );
}